export default "__VITE_ASSET__5387f06b__"